import { useNavigate } from "react-router-dom"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { ModalTypes } from "../../../Interfaces/ContextInterfaces/GeneralContext"
import { HasPreviousAppEntry } from "../../../Helpers/RouteHelpers"
import "./BackButton.css"

// Returns to the previous screen like the browser button does. A screen opened from a link
// or a reload has no previous screen, so it goes to the list it belongs to instead.
function BackButton({ fallbackSection }: { fallbackSection: ModalTypes['type'] }) {

	const navigate = useNavigate()
	const { setCurrentModal } = useGeneralContext()

	const handleClick = () => {
		if (HasPreviousAppEntry()) {
			navigate(-1)
		} else {
			setCurrentModal(fallbackSection)
		}
	}

	return (
		<div className="BackButtonDiv">
			<button type='button' onClick={handleClick}>
				← Volver
			</button>
		</div>
	)
}

export default BackButton
